import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5054ba5f")

_pushScopeId("data-v-5054ba5f")
const _hoisted_1 = { class: "CompletedCargo" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "CompletedCargo__header" }, [
  /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "О вашем грузе")
], -1)
const _hoisted_3 = { class: "CompletedCargo__body" }
const _hoisted_4 = { class: "body__row" }
const _hoisted_5 = { class: "body__col" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Вес груза", -1)
const _hoisted_7 = { class: "col__text" }
const _hoisted_8 = { class: "body__col" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Объём груза", -1)
const _hoisted_10 = { class: "col__text" }
const _hoisted_11 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_12 = { class: "body__col" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Количество мест", -1)
const _hoisted_14 = { class: "col__text" }
const _hoisted_15 = { class: "body__row" }
const _hoisted_16 = {
  key: 0,
  class: "body__col"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Примечания к отправке", -1)
const _hoisted_18 = { class: "col__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.cargo.weight) + " кг", 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("p", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.cargo.volume) + " м", 1),
            _hoisted_11
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("p", _hoisted_14, _toDisplayString(_ctx.cargo.places) + " " + _toDisplayString(_ctx.declOfNum(_ctx.cargo.places, _ctx.PLACES_TOKENS)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        (_ctx.cargo.annotation)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("p", _hoisted_18, _toDisplayString(_ctx.cargo.annotation), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})